export default {
    transactions_details_title: 'Transactions Details',
    transactions_details_created: 'Created',
    transactions_details_transaction: 'Transaction Id',
    transactions_details_status: 'Status',
    transactions_details_type: 'Type',
    transactions_details_message: 'Message',
    transactions_details_data: 'Data',
    transactions_details_created_by: 'Created By',
    transactions_details_duplicated_device: "Duplicated Device",
    transactions_details_processed: "Processed",
    transactions_details_failure: "Failure",
    transactions_details_pending: "Pending",
    transactions_details_in_progress: "In Progress",
    transactions_details_void: "Void",
    transactions_details_unsubscribed: "Unsubscribed",
    transactions_details_delivered: "Delivered",
    transactions_details_show_data: 'Show Data',
    transactions_details_unit: 'Unit',
    transactions_details_details: 'Details',
    transactions_details_esn: 'ESN',
    transactions_details_hardwareVersion: 'Hardware Version',
    transactions_details_to: 'To',



    transactions_details_type_units: 'Unit',
    transactions_details_type_assets: 'Asset',
    transactions_details_type_subUsers: 'Subuser',
    transactions_details_type_drivers: 'Driver',
    transactions_details_name: 'Name',

    transactions_details_type_assetSubtypes: 'Asset Subtype',
    transactions_details_type_account: 'Account',

    transactions_details_units: 'Units',
    transactions_details_status_changed: 'Status Changed To',
};